import classNames from 'classnames';
import CurrencyFormat from 'react-currency-format';
import { Divider } from 'rsuite';
import BaseCell, { BaseCellProps } from '../../../../../../../components/TableCells/BaseCell/BaseCell';
import { CompetitivenessPriceIndicator, MoneyPercentageIndicator } from '../../../../../Negociacoes/pages/NegociacaoFornecedor/components';
import { IRowData } from '../OfferTable/OfferTable';
import { getOfferInlineMetrics } from '../OfferTable/offerInlineMetrics';

export type PrecoVigenteCellProps = BaseCellProps & {
  rowData: IRowData;
};

const PrecoVigenteCellCampanha = ({ className, rowData, ...props }: PrecoVigenteCellProps) => {
  const { retail_price, margin_price_retail } = rowData;
  const { retail_price_cpi } = getOfferInlineMetrics(rowData, rowData.offer_final_price ?? null);

  return (
    <BaseCell className={classNames(className)} {...props}>
      <BaseCell.MainContainer>
        {retail_price ? (
          <CurrencyFormat fixedDecimalScale decimalScale={2} value={retail_price} displayType="text" prefix="R$ " decimalSeparator="," thousandSeparator="." />
        ) : (
          '--'
        )}
      </BaseCell.MainContainer>
      <BaseCell.SubContainer style={{ gap: '0px' }}>
        <MoneyPercentageIndicator value={margin_price_retail} tooltip="Margem do preço regular vigente" />
        <Divider vertical />
        <CompetitivenessPriceIndicator value={retail_price_cpi} />
      </BaseCell.SubContainer>
    </BaseCell>
  );
};

export default PrecoVigenteCellCampanha;
